import styled from 'styled-components'

export const ManageUsersLabel = styled.div`
  display: inline-block;
  vertical-align: middle;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: rgba(32, 32, 32, 0.7);
  padding-left: 6px;
`

export const ManageCategoryLabel = styled.div`
  display: inline-block;
  vertical-align: middle;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: rgba(10, 161, 244, 1);
  padding-left: 6px;
`

export const ManageUsersSeparator = styled.div`
  display: inline-block;
  vertical-align: middle; 
  margin: 4px 6px 0 16px;
  width: 8px;
  height: 8px;
  background: rgba(10, 161, 244, 1);
  border-radius: 50%;
`

export const CommentArea = styled.div`
  :hover {
    border: 1px solid rgba(10, 161, 244, 0.5);
    box-shadow: 0px 1px 2px rgba(32, 32, 32, 0.05), 0px 0px 0px 4px rgba(10, 161, 244, 0.1);
    border-radius: 4px;
  }
  position: relative;
  border: 1px solid rgba(32, 32, 32, 0.2);
  box-sizing: border-box;
  box-shadow: 0px 1px 2px rgba(32, 32, 32, 0.05);
  border-radius: 4px;
`
export const TextAreaControls = styled.div`

`
export const CommentButtonsLeft = styled.div`
 position: absolute;
 display: flex;
 left: 5px;
 bottom: 0;

 button {
    :hover {
        background: rgba(32, 32, 32, 0.05);
        border-radius: 20px;
        color: rgba(32, 32, 32, 1);
    }
 }
`
export const CommentButtonsRight = styled.div`
 position: absolute;
 display: flex;
 right: 5px;
 bottom: 0;
`
export const LeaveCommentBg = styled.div`
  cursor: ${(p) => {
    return p.enable ? 'pointer' : 'not-allowed'
  }};
  width: 40px;
  height: 40px; 
  background: ${(p) => {
    return p.enable ? 'rgba(10, 161, 244, 1)' : 'rgba(10, 161, 244, 0.5)'
  }};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const FormatTextArea = styled.div`
border: none;
box-shadow: none;
border-radius: none;
`
